import { motion, useInView } from 'motion/react';
import { useRef } from 'react';
import { Quote, Star } from 'lucide-react';
import { ImageWithFallback } from './figma/ImageWithFallback';

export function Testimonials() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });

  const testimonials = [
    {
      name: 'Ferran Tchatchoua',
      role: 'CTO at Brand Electronics',
      image: require("../assets/testimonial_1.jpeg"),
      content: 'Exceptional developer with an incredible eye for detail. Delivered our project ahead of schedule with innovative solutions we hadn\'t even considered.',
      rating: 5,
    },
    {
      name: 'Chare Abou Hanipha',
      role: 'Founder at Reclick Center',
      image: require("../assets/testimonial_2.jpeg"),
      content: 'The level of professionalism and technical expertise is unmatched. Transformed our vision into a scalable, production-ready application.',
      rating: 5,
    },
    {
      name: 'Theodore Wamba Kenang',
      role: 'Product Manager at Master Computers',
      image: require("../assets/testimonial_3.jpeg"),
      content: 'Working together was seamless. Great communication, problem-solving skills, and the ability to translate complex requirements into elegant code.',
      rating: 5,
    },
  ];

  return (
    <section className="py-32 px-6 bg-slate-900/50 relative overflow-hidden" ref={ref}>
      <div className="max-w-7xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="mb-4">
            Client <span className="bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">Testimonials</span>
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 mx-auto" />
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="relative group"
            >
              <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm border border-cyan-500/20 rounded-2xl p-8 hover:border-cyan-500/50 transition-all hover:shadow-2xl hover:shadow-cyan-500/20">
                {/* Quote icon */}
                <div className="absolute -top-4 -left-4 p-3 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-xl">
                  <Quote className="text-white" size={24} />
                </div>

                {/* Rating */}
                <div className="flex gap-1 mb-4 mt-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="text-yellow-400 fill-yellow-400" size={16} />
                  ))}
                </div>

                <p className="text-slate-300 mb-6 italic">"{testimonial.content}"</p>

                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-cyan-500/50">
                    <ImageWithFallback
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <p className="text-slate-100">{testimonial.name}</p>
                    <p className="text-slate-400 text-sm">{testimonial.role}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
